import { atom } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../../core/table/table.types';
import { tableStatsVM, tableViewVM, tableStateVM } from '../../../../core/table/table_view_models';
import { MonitorDefaultItem } from '../../data/datamonitorRepo';

export const defaultsTableStateAtom = atom<TableState>(tableStateVM());
export const defaultsTableViewAtom = atom<TblView>(tableViewVM());
export const defaultsTableFiltersAtom = atom<TableFilters>({});
export const defaultsTableStatsAtom = atom<TblStats>(tableStatsVM());
export const defaultsDataAtom = atom<TableDataState<MonitorDefaultItem>>({ items: [], dataItems: [] });
